import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appControlPaste]'
})
export class ControlPasteDirective {

  constructor() { }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

}
